import TalentAvailabilityForm from './Form';

export default TalentAvailabilityForm;
